//#region src/utils/zod-to-json-schema/parsers/enum.ts
function parseEnumDef(def) {
	return {
		type: "string",
		enum: Array.from(def.values)
	};
}

//#endregion
export { parseEnumDef };
//# sourceMappingURL=enum.js.map